// All times in IST (Asia/Kolkata, UTC+5:30)

export const getNowIST = () =>
  new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });

export const getISTHour = () => {
  const ist = new Date().toLocaleString('en-US', {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    hour12: false,
  });
  return parseInt(ist, 10);
};

export const getTimeIST = () =>
  new Date().toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata' });

export const getTodayDate = () => {
  // Returns YYYY-MM-DD in IST
  const ist = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
  return ist; // en-CA gives YYYY-MM-DD format
};

export const getDayOfWeek = () => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[new Date().getDay()];
};

export const toISOString = () => new Date().toISOString();

// Session detection (IST hours)
export const getCurrentSession = () => {
  const hour = getISTHour();
  if (hour >= 5  && hour < 9)  return { name: 'Pre-London',    emoji: '🌅', quality: 'LOW',  color: '#ccaa00' };
  if (hour >= 9  && hour < 14) return { name: 'London',        emoji: '🇬🇧', quality: 'HIGH', color: '#00d4ff' };
  if (hour >= 14 && hour < 20) return { name: 'London + NY',   emoji: '🔥', quality: 'PEAK', color: '#00ff88' };
  if (hour >= 20 && hour < 24) return { name: 'NY Close',      emoji: '🗽', quality: 'MED',  color: '#7ab3cc' };
  return                               { name: 'Asian',         emoji: '🌏', quality: 'LOW',  color: '#3a6a7a' };
};

// Time until next London open (IST 09:00)
export const timeUntilLondon = () => {
  const now = new Date();
  const istNow = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  const target = new Date(istNow);
  target.setHours(9, 0, 0, 0);
  if (istNow >= target) target.setDate(target.getDate() + 1);
  const diff = Math.floor((target - istNow) / 60000); // minutes
  const h = Math.floor(diff / 60);
  const m = diff % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

// Relative date label
export const getRelativeDate = (dateStr) => {
  const today = getTodayDate();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = yesterday.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
  if (dateStr === today) return 'Today';
  if (dateStr === yesterdayStr) return 'Yesterday';
  return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};
